// Theme tokens para Ant Design (antd v5 ConfigProvider), calcados de la marca
// Ontiveros & Asociados que hoy vive en assets/css/lux_brand_colors.css:
//   Primario:   #0A539A (navy) — hover #0D63B5, activo #083F78
//   Secundario: #5CAFC5 (teal) — se mantiene fuera de antd (usado en CSS propio
//   del sidebar/header, --eh-accent) porque antd no tiene un slot de "secondary"
//   equivalente al de Bootstrap; los componentes antd solo necesitan primary.
//   Semánticos tomados de --eh-blue/--eh-red/--eh-amber (styles.css).
export const antdTheme = {
  token: {
    colorPrimary: "#0A539A",
    colorPrimaryHover: "#0D63B5",
    colorPrimaryActive: "#083F78",
    colorLink: "#0A539A",
    colorLinkHover: "#083F78",
    colorLinkActive: "#083F78",
    colorInfo: "#3b82f6",
    colorError: "#ef4444",
    colorWarning: "#f59e0b",
    borderRadius: 6,
    fontFamily: "var(--app-font-sans)",
  },
};
